<div class="container-fluid overflow-hidden" [ngClass]="{'h-100': !content?.cardHeight}"
  [ngStyle]="{ 'height': content?.cardHeight ? content.cardHeight + 'px' : 'auto' }">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
      <!-- <a class="linkTitle">View All</a> -->
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="container-fluid mb-3"
    [ngClass]="{'container-content': !content?.cardHeight, 'container-content-fixed-height': content?.cardHeight}">
    <div class="row" *ngFor="let item of notificationList">
      <div class="col-12 p-0">
        <div class="flex-container">
          <!-- <div class="flex-item bottom-dashed-shadow star-width">
            <span class="pi pi-star"></span>
          </div> -->
          <div class="flex-item bottom-dashed-shadow content-width">
            <div *ngIf="item.title">
              <span class="name" title="{{ item.title }}">{{ item.title }}</span>
            </div>
            <div *ngIf="item.text">
              <span class="description" title="{{ item.text }}">{{ item.text }}</span>
            </div>
            <div class="w-100" *ngIf="item.employeeDetails?.date">
              <span class="description" title="{{ item.employeeDetails?.date }}">{{ item.employeeDetails?.date }}</span>
            </div>
          </div>
          <div class="flex-item bottom-dashed-shadow status-width">
            <a class="status"
              *ngIf="item.employeeDetails?.dashboardNotificationType && ((content?.notificationRedirection && content.notificationRedirection[item.employeeDetails.dashboardNotificationType]) || item.employeeDetails.dashboardNotificationType === 'Onboarding')"
              (click)="onViewDetails(item)">View
              Details</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row pb-3">
    <div class="col-12 text-center">
      <a class="link">Show More</a>
    </div>
  </div> -->
</div>